export const KEY_ENDUSER_PSEUDO_ID = 'enduser.pseudo.id';
